import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface sharingoptionData {
  ID: string;
  USERNAME: string;
 
}



export interface UserList {
  ID: number;
  USERNAME: string;
  REMARKS: string;
 
}

export interface FetchUserList {
  ID: number;
 
}

@Component({
    selector: 'app-sharingoption-form',
    templateUrl: './sharingoption-form.component.html',
    styleUrls: ['./sharingoption-form.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})



export class sharingoptionFormComponent implements OnInit {
  @Input() formData: sharingoptionData[];
  form: FormGroup;
  submitted: boolean;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2030, 0, 1);
  pageurl: string;
  url: string;
  ReportID: any;
  buttonName: string;
  ID: Number;
  editable: boolean;
  UserName:string;
  ParameterFor: string;
  ContextID: string;
  RightsID: string;
  IsDisplayButton: string;
  PassStatus: any;
  selectedUser = [];
   userList: UserList[] = [];
  
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  Remarks: any;
 
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService ) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202054001') ) {
      this.IsDisplayButton="1";
    } else {
      this.IsDisplayButton="0";
    }
   
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.ParameterFor = pagehead[3];
    this.ContextID = pagehead[2];
    
    const formGroup = {};
   // this.form = new FormGroup(formGroup);
    this.buttonName = "Submit";
    this.form = this.formBuilder.group({
    
      drUser: [{value : this.ID}],
      drRemarks: [this.Remarks],
      drCase: [this.ContextID],
    });
   this.http.get(this.url + 'Notice/UserMaster')
   .subscribe( (data) =>   {
           if (data == null) {
           } else {
            this.userList = JSON.parse(data.toString());
           // this.selectedUser = this.userList;
             
           }});

      this.http.get(this.url + 'Notice/GetShareUser?NoticeID='+this.ContextID+'')
   .subscribe( (data) =>   {
           if (data == null) {
           } else {
          
            const NSM: UserList = JSON.parse(data.toString())[0];
           
            
            this.selectedUser= JSON.parse("[" + NSM.ID + "]");
             this.form.patchValue({
              drRemarks: NSM.REMARKS == null ? 0 : NSM.REMARKS, } );
             }
          });
  }

  
  
  submitForm() {
    this.submitted = true;
 
    console.log(this.form.value);
    this.http.post(this.url + 'Notice/InsertNoticeSharingOption', this.form.value).subscribe( (data) =>   {
          if (data == null) {
            this.alertService.error('Check Your InterNet Connection, Try Again Later',true);
          }
          else{
            
            
            this.alertService.success("Sharing Successfully", this.options);
          }
         }
      );
    }

}
